import { PageTypes } from '@shared/types';
export function checkIfPageHasTableOnly(pageType) {
    return PageTypes.tags === pageType || PageTypes.delivery === pageType;
}
